
import Form from '@/ui-kit/components/form';
import FormField from '@/ui-kit/components/form/form-field';
import Typography from '@/ui-kit/components/typography';
import Button from '@/ui-kit/components/button';
import { StyleColorSchemeType } from '@/ui-kit/styles/enums';
import { ControlType } from '@/ui-kit/components/form/controls/enums';
import createPMCancellationFormGroup from './controls/PMBookingCancellationFormControls';
import { RadioPropertyType } from '@/ui-kit/components/form/controls/components/radio/enums';
import OptionsHelper from '@/utils/OptionsHelper';

const CANCELLATION_OPTIONS = [
  'I need to reschedule',
  'I am no longer selling my property',
  'I have decided to list my property elsewhere',
  'I have more questions/would like to learn more before proceeding',
  'I have my own photos and measurements',
];

export default {
  name: 'BuilderListingAssignmentForm',
  components: {
    Form,
    FormField,
    Typography,
    Button,
  },
  data() {
    return {
      formGroup: createPMCancellationFormGroup(),
      ControlType,
      StyleColorSchemeType,
    };
  },
  computed: {
    isFormValid() {
      return this.formGroup.isValid;
    },
    isSubmitDisabled() {
      return !this.formGroup.value.cancellationReason;
    },
    controlProps() {
      return {
        [RadioPropertyType.Name]: 'cancellationReason',
        [RadioPropertyType.Options]: OptionsHelper.mapValuesIntoOptions(CANCELLATION_OPTIONS),
      };
    },
  },
  methods: {
    handleExitModalClick() {
      this.$emit('cancel');
    },
    handleCancelBookingClick() {
      this.formGroup.validate();

      if (this.isFormValid) {
        this.$emit('submit', this.formGroup.value.cancellationReason);
      }
    },
  },
};
